import { AxiosResponse } from "axios";

import { VITE_TENANT_ORION } from "@/constants";
import { axiosInstanceOrion } from "@/service/Axios";

import { OrionV2AuthenticateResponseT } from "./orionv2.types";

type postOrionLoginBody = {
  user: string;
  password: string;
};

export const postOrionLogin = async (
  data: postOrionLoginBody,
): Promise<OrionV2AuthenticateResponseT> => {
  const TENANT = VITE_TENANT_ORION;
  return await axiosInstanceOrion
    .post<postOrionLoginBody, AxiosResponse<OrionV2AuthenticateResponseT>>(
      `v1/securitycore/authentication/business/login`,
      data,
      {
        headers: {
          "X-Tenant": TENANT,
        },
      },
    )
    .then((r) => r.data);
};
